<template>
  <Navbar />
  <div class="title">
    <h1>
      <fa class="icon" icon="hammer" /><span class="title-text"
        >Under Construction!</span
      >
    </h1>
    <p>
      Sorry... This page is not yet finished, but we are working hard to deliver
      it as soon as possible.
    </p>
  </div>
  <div class="tape"></div>
  <div class="tape" style="top: calc(100% - 6em)"></div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

export default {
  name: "UnderConstruction",
  components: { Navbar },
};
</script>

<style scoped>
.icon {
  transform-origin: 20% 85%;
  animation-name: rotate;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in;
}
.title {
  width: 100%;
  height: 100%;
  background: var(--light-clr);
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 3em;
}

.title-text {
  animation-name: rock-right;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  display: inline-flex;
}

.title h1 {
  overflow: visible;
  white-space: nowrap;
}

.tape {
  width: 100%;
  height: 6em;
  position: absolute;
  top: 0%;
  background: repeating-linear-gradient(
    135deg,
    var(--dark-clr) 2em 4em,
    var(--primary-clr) 4em 6em
  );
  box-shadow: var(--box-shadow-focus);
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-15deg);
  }
  65% {
    transform: rotate(-15deg);
  }
  70% {
    transform: rotate(0deg);
  }
  77% {
    transform: rotate(-4deg);
  }
  80% {
    transform: rotate(0deg);
  }
}

@keyframes rock-right {
  0% {
    transform: translateX(0);
  }
  70% {
    transform: translateX(0);
  }
  77% {
    transform: translateX(0.3em);
  }
  82% {
    transform: translateX(0);
  }
  86% {
    transform: translateX(0.1em);
  }
  90% {
    transform: translateX(0);
  }
}

@media screen and (max-width: 40rem) {
  .title h1 {
    font-size: 1.2em;
  }
}
</style>
